import React, { Component } from "react";
import { connect } from "react-redux";

class outtime extends Component {
  render() {
    document.body.classList.add("modal-open");
    return (
      <div
        className="body-out"
        style={{ top: "0", zIndex: "1040", position: "fixed", width: "100%" }}
      >
        <div className="box-out-time">
          <div className="out-text">
            <p>
              หมดเขตแคมเปญของ <span>{this.props.project.project_name}</span>{" "}
              แล้วค่ะ
            </p>
          </div>
          <div className="out-img">
            <img alt="web@2x" src="/cust/web/images/logo/web@2x.png" className="logo" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  project: state.project.info
});

export default connect(
  mapStateToProps,
  null
)(outtime);
